<app-popup-layout #modal>
  <div class="modal-container">
    <div class="modal-header">
      <p class="modal-title">Create Outstanding</p>
    </div>

    <div class="modal-sub-body">
      <div class="row" [formGroup]="form">
        <div class="col-12 col-sm-12 col-md-12 mb-12">
          <span class="modal-body-group-content form-line-spacing">Amount</span>
          <span class="asterix--before"> </span>
          <!-- <div class="input-text-container height-35 d-flex align-items-center">
          <p class="rupee-sign me-2">&#x20b9;</p>
          <input
            appAutoFocus
            type="number"
            placeholder="Amount"
            formControlName="amount"
            />
        </div> -->

        <app-input-amount-field
          type="latest"
          class="d-flex"
          placeholder="Ex: 25000"
          [isError]="!!allocationAmount.errors"
          formControlName="amount"
        ></app-input-amount-field>

        <!-- {{ form.get("amount").errors | json }} -->
        @if (form.get('amount').value && !form.get('amount').errors) {
          <p
            class="in-words mt-2"
            >
            {{ getNumberToWords(form.get("amount").value) }}
          </p>
        }
        <mat-error>
          <app-form-field-error
            [form]="form"
            [formControlRef]="form.get('amount')"
              [messages]="{
                required: 'Enter the Amount',
                min: 'Amount should be greater than 1',
                pattern: 'Invalid Amount',
                max: 'Amount should not be greater than 99 crore '
              }"
            >
          </app-form-field-error>
        </mat-error>
      </div>

      <div class="col-12 col-sm-12 col-md-12 mb-12">
        <span class="modal-body-group-content form-line-spacing">
          Transaction Type</span
          >
          <span class="asterix--before"> </span>
          <mat-form-field appearance="fill" class="w-full" [floatLabel]="'never'">
            <mat-select
              name="cardTransactionType"
              formControlName="transactionType"
              [disableOptionCentering]="true"
              panelClass="over-lay-panel-bottom"
              >
              <mat-option [value]="'CR'">Credit</mat-option>
              <mat-option [value]="'DR'">Debit</mat-option>
            </mat-select>

            <mat-error>
              <app-form-field-error
                [form]="form"
                [formControlRef]="form.get('transactionType')"
              [messages]="{
                required: 'Please Select Transaction Type'
              }"
                >
              </app-form-field-error>
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-12 col-sm-12 col-md-12 mb-12">
          <span class="modal-body-group-content form-line-spacing">
            Remarks</span
            >
            <span class="asterix--before"> </span>

            <div class="input-text-container">
              <textarea
                rows="3"
                name="remarks"
                formControlName="remarks"
                placeholder="Write here"
              ></textarea>
            </div>

            <mat-error>
              <app-form-field-error
                [form]="form"
                [formControlRef]="form.get('remarks')"
              [messages]="{
                required: 'Enter the Remarks',
                maxlength: 'Remarks should be between 1-250 characters',
                pattern: 'Special characters are not allowed!'
              }"
                >
              </app-form-field-error>
            </mat-error>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          mat-flat-button
          color="accent"
          class="custom-button me-3"
          (click)="modal.dismiss()"
          >
          Cancel
        </button>

        <button
          mat-flat-button
          color="primary"
          class="custom-button"
          [disabled]="form.invalid"
          [appLoaderButton]="formActionRequestState()"
          (click)="onSave()"
          >
          Save
        </button>
      </div>
    </div>
  </app-popup-layout>
